import React, { useState, useEffect } from 'react';
import { Modal } from "react-bootstrap";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ReactGA from 'react-ga4';

import ScrollToTop from './ScrollToTop';
import PaymentSuccess from './PaymentSuccess'
import Travel from './Travel';
import LANDING from './LANDING';
import CLAIM from './Claims';
import Moment from 'moment';
import Faq from './Faqs';

ReactGA.initialize([{
	trackingId: 'G-S3JLQRW2KF',
	debug: true,
	gtagOptions: {
		cookieDomain: 'auto',
 		allowAdFeatures: true
	},

}]);


export default function App() {
	const [showSupportPopup, setShowSupportPopup] = useState(false);
	const [referral, setReferral] = useState('');
	const [travelDetails, setTravelDetails] = useState('');
	const [renewalParam, setRenewalParam] = useState('');
	const [renewalTag, setRenewalTag] = useState('');

	React.useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const rParam = urlParams.get('r');
		const mParam = urlParams.get('m');
		const pParam = urlParams.get('p');
		const tParam = urlParams.get('t');
  
		if (rParam) {
		  sessionStorage.setItem('referral', rParam);
		  //setReferral(sessionStorage.getItem('referral'));
		  setReferral(rParam);
		  console.log(rParam);
		}
  
		if(mParam) {
		  
		 console.log(mParam);	
		 const encodedParam = encodeURI(mParam);
		 const newparam =  encodedParam.replace(/%20/g, "+");
		 setTravelDetails(newparam);
		
		}

		if(pParam) {
			 console.log(pParam);	
			 setRenewalParam(pParam);
		}

		if(tParam) {
			 console.log(tParam);	
			 setRenewalTag(tParam);
		}

	  }, []);

	  useEffect(() => {
        //ReactGA.pageview(window.location.pathname + window.location.search);
ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search,title:"TravelPlus"});

 });


	return (
		<Router>
			<div id="content-wrapper" className="container-fluid">
				<nav className="navbar navbar-light navbar-expand-lg bg-transparent">
					<div className="container">
						<div className="navbar-brand d-flex text-white clickable">
							<a href={process.env.MIX_INSTAPOL_DOMAIN}>
								<img className="instapol-logo" src="../images/instapol-new-white-logo.png" alt="Howden Insurance Brokers Sdn Bhd" loading="lazy" />
							</a>
						</div>
						{/* <button className="navbar-toggler text-white border-0" type="button" data-bs-toggle="collapse" data-target="#navbar">
							<i className="fas fa-bars" />
						</button> */}

						<button className="navbar-toggler text-white border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbar" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
							<i className="fas fa-bars" />
						</button>

						<div className="collapse navbar-collapse" id="navbar">
							<ul className="navbar-nav ms-auto">
								<li className="nav-item">
									<a className="nav-link text-white fw-bold" href={process.env.MIX_INSTAPOL_DOMAIN}>Home</a>
								</li>

								<li class="nav-item dropdown">
									<a class="nav-link dropdown-toggle text-white fw-bold" href="#" id="productDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
										Our Products
									</a>
									<ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
										<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_DOMAIN + "/motor"}>Motor Insurance</a></li>
										<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_DOMAIN + "/bike"}>Bicycle Insurance</a></li>
										<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_DOMAIN + "/travel"}>Travel Insurance</a></li>
									</ul>
								</li>
								
								<li className="nav-item dropdown">
									<a className="nav-link text-white fw-bold dropdown-toggle" id="aboutDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
										About Us
									</a>
									<ul className="dropdown-menu" aria-labelledby="aboutDropdown">
										<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_DOMAIN + "/about-us"}>About instaPol</a></li>
										<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_PRIVACY}>Privacy Policy</a></li>
										<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_DOMAIN + "/refund-policy"}>Refund Policy</a></li>
										<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_COOKIES}>Cookies Policy</a></li>
										<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_TREMS}>Terms and Conditions</a></li>
									</ul>
								</li>
								<li>
									<a className="btn btn-outline-primary text-white fw-bold" href="/faq">FAQs</a>
								</li>
								<li>
									<a className="btn btn-outline-primary text-white fw-bold" href="/claims">Contact Us & Claims</a>
								</li>
							</ul>
						</div>
					</div>
				</nav>
				<ScrollToTop />
				<Switch>
					<Route exact path="/faq">
						<Faq />
					</Route>
					<Route exact path="/success">
						<PaymentSuccess />
					</Route>
					<Route exact path="/LANDING">
						<LANDING referral={referral} setReferral={setReferral} travelDetails={travelDetails} renewalParam={renewalParam} renewalTag={renewalTag}/>
					</Route>
					<Route exact path="/Travel">
						<Travel referral={referral} setReferral={setReferral}  travelDetails={travelDetails} renewalParam={renewalParam} renewalTag={renewalTag}/>
					</Route>
					<Route exact path="/claims">
						<CLAIM />
					</Route>
				</Switch>

				<div className="row">
					<div className="col-4 float-right btn-group-fab" role="group">
						<>
							<button type="button" className="btn btn-primary" data-placement="left" title="Contact Us" onClick={() => setShowSupportPopup(true)}>
								<i className="fas fa-comment-alt"></i>
							</button>
						</>
					</div>
				</div>
			</div>
			<section id="footer" className="mt-4 mr-3">
				<div className="row">
					<div className="col-12">
						<footer id="home-footer">
							<div className="container">
								<div className="row">
									<div className="col-12 col-sm-7 text-center text-sm-start">
										<a href={process.env.MIX_INSTAPOL_DOMAIN}>
											<img src="../images/instapol-new-logo.png" id="instapol-logo" alt="Instapol" width={150} loading="lazy" />
										</a>
										<div className="d-flex row mt-3">
											<div className="col-4 col-sm-3 border-right">
												<a className="btn btn-link" href={process.env.MIX_INSTAPOL_PRIVACY}>
													Privacy Notice
												</a>
											</div>
											<div className="col-4 col-sm-3 border-right">
												<a className="btn btn-link" href={process.env.MIX_INSTAPOL_DOMAIN + "/refund-policy"}>
													Refund Policy
												</a>
											</div>
											<div className="col-4 col-sm-3">
												<a className="btn btn-link" href={process.env.MIX_INSTAPOL_TREMS}>
													Terms &amp; Conditions
												</a>
											</div>
											<div className="col-4 col-sm-3">
												<a className="btn btn-link" href="https://www.howdengroup.com/my-en/complaints_handling">
													Complaints Handling and Resolution Guide
												</a>
											</div>

										</div>
										<p>Copyright &copy; 2021 Instapol. All rights reserved.</p>
									</div>
									<div className="col-12 col-sm-5 text-center text-sm-end mt-4 mt-sm-0">
										<p>Developed and owned by</p>
										<a href="https://www.howdengroup.com/my-en">
											<img src="../images/Howden_Corporate_Logo_CobaltBlue_RGB.png" id="howden-logo" alt="Howden Insurance Brokers Sdn Bhd" width={200} loading="lazy" />
										</a>
										<p className="mt-3 mb-0">Howden Insurance Brokers Sdn. Bhd. (197801001023)</p>
										<p>Howden Takaful Brokers Sdn. Bhd. (198001010734)</p>
									</div>
								</div>
							</div>
						</footer>
					</div>
				</div>
			</section>
			<Modal show={showSupportPopup} onHide={() => setShowSupportPopup(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Contact Us</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row text-dark-primary">
						<div className="col-10">
							<h5>WhatsApp:</h5>
							<a target="_blank" href={"https://api.whatsapp.com/send?phone=60122606183&text=" + process.env.MIX_APP_NAME}>+60122606183</a>
						</div>
					</div>
					<div className="row text-dark-primary">
						<div className="col-10">
							<h5>Email:</h5>
							<a href="mailto:insta.admin@my.howdengroup.com">insta.admin@my.howdengroup.com</a>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		</Router>
	);
}